import { render, staticRenderFns } from "./DialogCongratulationsResearch.vue?vue&type=template&id=affb14be&scoped=true"
import script from "./DialogCongratulationsResearch.vue?vue&type=script&lang=js"
export * from "./DialogCongratulationsResearch.vue?vue&type=script&lang=js"
import style0 from "./DialogCongratulationsResearch.vue?vue&type=style&index=0&id=affb14be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affb14be",
  null
  
)

export default component.exports